import { useState } from "react"
import { studentRequest } from "services/requests"
import { useGlobalAlert } from "contexts/GlobalAlertContext"

const prefix = "teacherMessages"

const useApi = () => {
  const [isFetching, setIsFetching] = useState(false)
  const { showAlert } = useGlobalAlert()

  const getStudentMessages = async () => {
    setIsFetching(true)
    const response = await studentRequest.sendRequest({
      endpoint: `${prefix}`,
      body: null,
      method: "get",
    })
    if (!response.success) showAlert(response.message)
    setIsFetching(false)
    return response.data
  }

  const getUnreadNotificationsCount = async () => {
    setIsFetching(true)
    const response = await studentRequest.sendRequest({
      endpoint: `${prefix}/GetUnreadMessagesCount`,
      body: null,
      method: "get",
    })
    if (!response.success) showAlert(response.message)
    setIsFetching(false)
    return response.data
  }

  // get technical report with all grade and general announce data
  const getTechnicalReport = async ({ reportId }) => {
    setIsFetching(true)
    const response = await studentRequest.sendRequest({
      endpoint: `${prefix}/getMessagesReport/${reportId}`,
      body: null,
      method: "get",
    })
    if (!response.success) showAlert(response.message)
    setIsFetching(false)
    return response.data
  }

  const getAnnounce = async ({ announceId }) => {
    setIsFetching(true)
    const response = await studentRequest.sendRequest({
      endpoint: `${prefix}/getAnnounce/${announceId}`,
      body: null,
      method: "get",
    })
    if (!response.success) showAlert(response.message)
    setIsFetching(false)
    return response.data
  }

  return {
    isFetching,
    getStudentMessages,
    getUnreadNotificationsCount,
    getTechnicalReport,
    getAnnounce,
  }
}

export default useApi
